import Link from 'next/link';
import React, { useContext } from 'react';
import BridgeLink from '@/components/base/BridgeLink';
import LocalStationLogo from '@/components/global/LocalStationLogo';
import StationLocalizationContext from '@/contexts/StationLocalizationContext';
import { StationLogoTheme } from '@/types/stations';
import LanguageLocalizer from '@/utils/language-localization';
import SharedFooterLinks from './SharedFooterLinksView';
import styles from './StandardFooter.module.scss';

export default function StandardFooter() {
  const { __t } = new LanguageLocalizer( useContext, 'components/global/SiteFooter' );
  const { station } = useContext(StationLocalizationContext);
  return <>
    <footer className={styles.mainContainer}>
      <ul className={styles.links}>
        <li><Link href={'/grownups/'}>{__t('grownups')}</Link></li>
        <li><Link href={'/apps/'}>{__t('apps')}</Link></li>
        <li>
          <BridgeLink
            href={'https://help.pbs.org/support/solutions/12000004780'}
            title={'help'}
          >
            {__t('help')}
          </BridgeLink>
        </li>
        {station.tvssUrl && <li>
          <BridgeLink
            href={station.tvssUrl}
            title={`${station.commonName} TV schedule`}
          >
            {__t('tvTimes')}
          </BridgeLink>
        </li>}
      </ul>

      <LocalStationLogo
        logoTheme={StationLogoTheme.White} // Hardcoded since the footer is not themed currently.
        prependElement={
          <p>{__t('from')}</p>
        }
        wrapperClasslist={styles.logoWrapper}
        innerClasslist={styles.stationLogo}
        sizes='300px'
      />

      <SharedFooterLinks />
    </footer>
  </>;
}
